import { Box, Flex, Input, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { unformatDollarString } from "utils/helpers";

const FilterSlider = ({
  field,
  setField,
  formatter,
}: {
  field: any;
  setField: (range: any) => void;
  formatter: (val: number) => string;
}) => {
  const [range, setRange] = useState<{
    min: string | number;
    max: string | number;
  }>(
    field.value || {
      min: "",
      max: "",
    },
  );

  useEffect(() => {
    setField(range);
  }, [range]);

  return (
    <Flex alignItems="center">
      <Input
        h="auto"
        textAlign="center"
        type="text"
        py="4px"
        placeholder="$0"
        value={formatter(range.min as number)}
        variant="primary"
        onChange={(ev) =>
          setRange({
            ...range,
            min: unformatDollarString(ev.target.value),
          })
        }
      />
      <Box mx="10px">
        <Text>to</Text>
      </Box>
      <Input
        h="auto"
        textAlign="center"
        type="text"
        py="4px"
        placeholder="$0"
        value={formatter(range.max as number)}
        variant="primary"
        onChange={(ev) =>
          setRange({
            ...range,
            max: unformatDollarString(ev.target.value),
          })
        }
      />
    </Flex>
    // <Flex>
    //   <Flex justifyContent="space-between">
    //     <BoundsText val={formatter(0)} />
    //     <BoundsText val={formatter(100)} />
    //   </Flex>

    //   <RangeSlider
    //     aria-label={["min", "max"]}
    //     defaultValue={range}
    //     onChange={setRange}>
    //     <RangeSliderTrack>
    //       <RangeSliderFilledTrack />
    //     </RangeSliderTrack>
    //     <RangeSliderThumb index={0} />
    //     <RangeSliderThumb index={1} />
    //   </RangeSlider>
    // </Flex>
  );
};

export default FilterSlider;
